/**
 * @file
 * Fichier de gestion des comportements JavaScript pour les différents blocs et composants du thème.
 *
 * Ce fichier gère les manipulations DOM et l'initialisation des carrousels
 * pour divers composants de la page, notamment les bannières d'accueil,
 * les compteurs, et les listes de clients et d'innovations.
 */

import $ from 'jquery';
import 'slick-carousel';

/**
 * Initialisation des comportements de blocs au chargement du DOM.
 *
 * Exécute diverses manipulations DOM et initialise les carrousels
 * pour améliorer l'interface utilisateur et l'expérience visuelle.
 */
$(document).ready(function() {
  // Structuration de la bannière d'accueil
  /**
   * Regroupe le titre et le lien de la bannière d'accueil dans un conteneur div.
   *
   * Cette manipulation permet de faciliter le positionnement CSS et d'améliorer
   * la structure sémantique du composant.
   */
  $('.paragraph--type--accueil-banniere .title-banner, .paragraph--type--accueil-banniere a').wrapAll('<div class="content"></div>');

  /**
   * Ajoute la classe 'count' au premier div des compteurs.
   *
   * Cette classe permet de cibler et de styler spécifiquement le conteneur
   * des compteurs dans les CSS.
   */
  $('.paragraph--type--compteurs > div').first().addClass('count');

  /**
   * Initialise le carrousel pour la liste des clients.
   *
   * Configuration du carrousel avec des paramètres responsives adaptés aux
   * différentes tailles d'écran. Le nombre d'éléments affichés s'adapte
   * en fonction de la largeur de l'écran.
   *
   * @param {Object} $slider - Référence jQuery à l'élément slider
   * @param {number} slideCount - Nombre total d'éléments dans le slider
   */
  var $slider = $('.clients ul.clients-list');
  var slideCount = $slider.children().length;
  $('.clients ul.clients-list').slick({
    slidesToShow: Math.min(5, slideCount), // Limite à 5 éléments ou moins si moins d'éléments disponibles
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024, // Point de rupture tablette
        settings: {
          slidesToShow: Math.min(3, slideCount), // 3 éléments sur tablette
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600, // Point de rupture mobile
        settings: {
          slidesToShow: 1, // 1 élément sur mobile
          slidesToScroll: 1,
        }
      }
    ]
  });

  /**
   * Ajuste dynamiquement la largeur des slides en fonction du nombre d'éléments.
   *
   * Si le nombre d'éléments est inférieur à 5, répartit équitablement
   * la largeur disponible entre les éléments.
   */
  $(window).on('resize load', function() {
    if ($slider.slick('getSlick').slideCount < 5) {
      var slideWidth = 100 / $slider.slick('getSlick').slideCount;
      $slider.find('.slick-slide').css('width', slideWidth + '%');
    } else {
      $slider.find('.slick-slide').css('width', ''); // Réinitialise aux valeurs par défaut
    }
  });

  /**
   * Initialise le carrousel pour la liste des innovations.
   *
   * Configuration du carrousel avec des paramètres responsives adaptés
   * aux différentes tailles d'écran. Contrairement au slider des clients,
   * l'autoplay est désactivé pour permettre une lecture plus attentive.
   */
  $('.innovations ul.innovations-list').slick({
    slidesToShow: 3, // 3 éléments sur desktop
    slidesToScroll: 1,
    autoplay: false, // Pas de défilement automatique
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024, // Point de rupture tablette
        settings: {
          slidesToShow: 2, // 2 éléments sur tablette
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600, // Point de rupture mobile
        settings: {
          slidesToShow: 1, // 1 élément sur mobile
          slidesToScroll: 1,
        }
      }
    ]
  });
});
